import { LengthUnit } from 'app/modules/wallforming/components/scenes/types/lengthUnit';

/**
 * - `projection`: mirrored, vertically compressed drawing below the floor that turns towards the camera
 * - `overlay`: true orthographic front view drawn directly in the wall plane
 */
export type DimensionDisplayMode = 'projection' | 'overlay';

/**
 * - `labels`: size labels placed inside the shapes (collision free, omitted when they do not fit)
 * - `chains`: ISO 129 dimension lines (chain dimensioning) outside the drawing
 * - `both`: labels and dimension lines
 */
export type DimensionAnnotationMode = 'labels' | 'chains' | 'both';

export interface DimensionChainSettings {
    panels: boolean;
    anchors: boolean;
    overall: boolean;
    heights: boolean;
}

/** Unit used for the dimension texts only; all geometry is kept in metres. */
export type DimensionUnit = 'm' | LengthUnit;

export const DIMENSION_UNITS: DimensionUnit[] = [
    'm',
    LengthUnit.CENTIMETER,
    LengthUnit.MILLIMETER,
    LengthUnit.INCHES,
    LengthUnit.FEET
];

export interface DimensionSettings {
    visible: boolean;
    displayMode: DimensionDisplayMode;
    annotationMode: DimensionAnnotationMode;
    unit: DimensionUnit;
    showConnectors: boolean;
    showAnchors: boolean;
    projectionVerticalScale: number;
    chains: DimensionChainSettings;
}

export const DEFAULT_DIMENSION_SETTINGS: DimensionSettings = {
    visible: true,
    displayMode: 'projection',
    annotationMode: 'both',
    unit: 'm',
    showConnectors: false,
    showAnchors: false,
    projectionVerticalScale: 0.4,
    chains: {
        panels: true,
        anchors: true,
        overall: true,
        heights: true
    }
};
